import sdl from '@jds/react-generated-sdl/JDSBottomNavigationItem';
import type { JDSBottomNavigationItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBottomNavigationItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    showLabel = false,
    active = false,
    disabled = false,
    multiLine = false,
    ariaLabel = props.label?.toString(),
    _ariaSelected = props.active?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      showLabel,
      active,
      disabled,
      multiLine,
      ariaLabel,
      _ariaSelected,
      ...rest
    },
    'JDSBottomNavigationItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BottomNavigationItem = withLogic(
  Component
) as React.FC<JDSBottomNavigationItemProps> & { slotName?: string };

BottomNavigationItem.displayName = 'BottomNavigationItem';
BottomNavigationItem.slotName = 'jds_bottom_navigation_item';

export { BottomNavigationItem, type JDSBottomNavigationItemProps };
